import get from 'lodash/get';
import {
  CREATE_CONTRACT_SUCCESS,
  CREATE_CONTRACT_FAILURE,
  EDIT_CONTRACT_SUCCESS,
  SUBMIT_FOR_APPROVAL_SUCCESS,
  SUBMIT_FOR_APPROVAL_FAILURE,
  APPROVE_CONTRACT_SUCCESS,
  REJECT_CONTRACT_SUCCESS,
} from '../actions/contracts';
import {
  APPROVE_AGREEMENT_SUCCESS,
  REJECT_AGREEMENT_SUCCESS,
  SUBMIT_AGREEMENT_FOR_APPROVAL_SUCCESS,
} from '../actions/agreements';
import {
  SUBMIT_EXISTING_ADJUSTMENT_SUCCESS,
  SUBMIT_ADJUSTMENT_SUCCESS,
  SUBMIT_EXISTING_ADJUSTMENT_FAILURE,
} from '../actions/adjustments';

import { CREATE_PARTNER_SUCCESS } from '../actions/partners';

import { APPROVAL_STATEMENT_SUCCESS, REGENERATE_STATEMENT_SUCCESS } from '../actions/statements';

import { showFlashMessage } from '../actions/ui';

const contracts =
  ({ dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case CREATE_CONTRACT_SUCCESS: {
        const contract = get(action, `payload.entities.contracts.${action.payload.result}`, {});
        dispatch(
          showFlashMessage(`Contract saved ${contract.approvalStatus === 'Draft' && 'as draft'}`, {
            type: 'success',
          }),
        );
        break;
      }

      case EDIT_CONTRACT_SUCCESS: {
        const contract = get(action, `payload.entities.contracts.${action.payload.result}`, {});
        const message =
          contract.approvalStatus === 'Approved' || contract.approvalStatus === 'Draft'
            ? 'Contract terms updated'
            : 'Contract terms submitted for approval';
        dispatch(showFlashMessage(message, { type: 'success' }));
        break;
      }

      case SUBMIT_FOR_APPROVAL_SUCCESS:
        dispatch(
          showFlashMessage('Contract submitted for approval', {
            type: 'success',
          }),
        );
        break;

      case SUBMIT_AGREEMENT_FOR_APPROVAL_SUCCESS:
        dispatch(
          showFlashMessage('Royalty Fee submitted for approval', {
            type: 'success',
          }),
        );
        break;

      case APPROVE_CONTRACT_SUCCESS: {
        const message = action.meta?.isEdit
          ? 'Edits successfully approved'
          : 'Contract successfully approved';
        dispatch(
          showFlashMessage(message, {
            type: 'success',
          }),
        );
        break;
      }

      case REJECT_CONTRACT_SUCCESS: {
        const message = action.meta?.isEdit
          ? 'Contract edits rejected and returned to the submitter'
          : 'Contract terms rejected and returned to the submitter';
        dispatch(
          showFlashMessage(message, {
            type: 'success',
          }),
        );
        break;
      }

      case APPROVE_AGREEMENT_SUCCESS: {
        dispatch(
          showFlashMessage('Royalty Fee updated', {
            type: 'success',
          }),
        );
        break;
      }

      case REJECT_AGREEMENT_SUCCESS: {
        dispatch(
          showFlashMessage('Royalty Fee edits rejected and returned to the submitter', {
            type: 'success',
          }),
        );
        break;
      }

      case CREATE_CONTRACT_FAILURE:
      case SUBMIT_FOR_APPROVAL_FAILURE:
        dispatch(
          showFlashMessage(action.payload.message, {
            type: 'error',
          }),
        );
        break;

      case APPROVAL_STATEMENT_SUCCESS:
        dispatch(
          showFlashMessage(action.meta.flashMessage, {
            type: 'success',
          }),
        );
        break;

      case REGENERATE_STATEMENT_SUCCESS:
        dispatch(
          showFlashMessage(action.meta.flashMessage, {
            type: 'success',
          }),
        );
        break;

      case SUBMIT_ADJUSTMENT_SUCCESS:
      case SUBMIT_EXISTING_ADJUSTMENT_SUCCESS: {
        dispatch(
          showFlashMessage(`Adjustment submitted for approval.`, {
            type: 'success',
          }),
        );
        break;
      }

      case SUBMIT_EXISTING_ADJUSTMENT_FAILURE:
        dispatch(
          showFlashMessage(`${action.payload.message}`, {
            type: 'error',
          }),
        );
        break;

      case CREATE_PARTNER_SUCCESS: {
        dispatch(
          showFlashMessage(`Partner created successfully.`, {
            type: 'success',
          }),
        );
        break;
      }

      default:
        break;
    }

    // keep the train moving!
    return next(action);
  };

export default contracts;
